import { useLanguage } from "../context/LanguageContext";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { usePageContent } from "../hooks/usePageContent";
import { SEO } from "../components/SEO";

export default function CookiePage() {
  const { t } = useLanguage();
  const { data, loading } = usePageContent("cookies");

  if (loading) return <div className="px-6 md:px-12 lg:px-24 py-20"><p className="text-sm text-[#9CA3AF]">{t("common.loading")}</p></div>;

  const sections = data?.sections || [];

  return (
    <div className="px-6 md:px-12 lg:px-24 py-12 md:py-20 max-w-3xl" data-testid="cookie-page">
      <SEO title="Cookie Policy" description="Mona Luxe cookie policy. Learn how we use cookies to improve your shopping experience." path="/cookies" />
      <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-[#9CA3AF] hover:text-[#1A1A1A] transition-colors mb-10">
        <ArrowLeft size={14} strokeWidth={1.5} /> {t("common.back")}
      </Link>
      <h1 className="text-3xl md:text-4xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }} data-testid="cookie-title">
        {data?.title || t("footer.cookies")}
      </h1>
      {data?.subtitle && <p className="text-xs text-[#9CA3AF] tracking-wide mb-12">{data.subtitle}</p>}

      <div className="space-y-10 text-sm leading-relaxed tracking-wide text-[#1A1A1A]/80">
        {sections.map((s, i) => (
          <section key={i}>
            <h2 className="text-base font-normal mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>{s.title}</h2>
            {s.content.split("\n").map((line, j) => (
              <p key={j} className={j > 0 ? "mt-2" : ""}>{line}</p>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
}
